<template>
	<div v-if="renderizar">
		<div class="row company-view " :class="scoreClass" v-if="solicitacao != null">
			<div class="col-12">
				<div class="row tit_page">
					<div class="col-12">
						<div class="float-left">
							<h1>Oportunidade <span>id#{{ solicitacao.IdOportunidade }}</span></h1>
						</div>
						<div class="back float-right">
							<router-link to="/investimentos/oportunidades" title="Voltar"><i>&nbsp;</i> voltar</router-link>
						</div>
						<div class="clearfix"></div>
					</div>
				</div>
				<hr class="divider">

				<div class="row">

					<!-- Inicio conteúdo -->
					<div class="col-12 col-lg-8">
						<div class="tit">
							<div class="float-left">
								<h2>{{solicitacao.Ccb.RazaoSocial}}</h2>
								<span>CNPJ: {{formatarCnpj(solicitacao.Documento)}}</span>
								<small>{{formatarTipoEmprestimo(solicitacao.TipoEmprestimo)}}</small>  
							</div>
							<div class="rating float-left float-md-right">
								<strong>Score da operação <span class="circle score"></span>{{ solicitacao.Score }}</strong>
							</div>
							<div class="clearfix"></div>
						</div>

						<section>
							<figure class="d-flex justify-content-center align-items-center">
								<img :src="solicitacao.Ccb.ArquivoBanner" height=700>
							</figure>
							
							<h4>Descrição sobre a empresa</h4>
							 <div v-html="solicitacao.Ccb.DescricaoEmpresa"></div>
							 <br>
							<h3>Dados da empresa</h3>
							<div class="row">
								<div class="col-12 col-lg-3">
									<label>Empresa <span>(Razão social)</span></label>
									<span>{{ solicitacao.Ccb.RazaoSocial }}</span>
								</div>
								<div class="col-12 col-lg-3">
									<label>CPF/CNPJ</label>
									<span>{{ formatarCnpj(solicitacao.Documento) }}</span>
								</div>
								<div class="col-12 col-lg-6">
									<label>Nome do responsável</label>
									<span>{{ solicitacao.Nome }}</span>
								</div>
								<div class="col-12 col-lg-3">
									<label>Nome fantasia</label>
									<span>{{ solicitacao.Ccb.NomeFantasia }}</span>
								</div>
								<div class="col-12 col-lg-3">
									<label >Telefone comercial</label>
									<span >{{ solicitacao.TelefoneComercial }}</span>
								</div>
								<div class="col-12 col-lg-6">
									<label>Data de fundação</label>
									<span>{{ formatMongoDate(solicitacao.Ccb.DataFundacao) }}</span>
								</div>
								<div class="col-12 col-lg-3">
									<label >Número de funcionários</label>
									<span>{{ solicitacao.Ccb.QuantidadeEmpregados }} empregados</span>
								</div>
								<div class="col-12 col-lg-3">
									<label>Nome do grupo ecônomico</label>
									<span>{{ solicitacao.Ccb.NomeGrupoEconomico }}</span>
								</div>
								<div class="col-12 col-lg-6">
									<label>Formato  do Investimeno</label>
									<span>{{ solicitacao.Ccb.FormatoInvestimento }}</span>
								</div>
								<div class="col-12">
									<label>Endereço</label>
									<span>{{ solicitacao.Ccb.Endereco.Logradouro }}, {{ solicitacao.Ccb.Endereco.Numero }}, {{ solicitacao.Ccb.Endereco.Bairro }} - {{ solicitacao.Ccb.Endereco.Cep }}, {{ solicitacao.Ccb.Endereco.Cidade }}/{{ solicitacao.Ccb.Endereco.Uf }}</span>
								</div>
								<div class="col-12 col-lg-6">
									<label>Site</label>
									<span>{{ solicitacao.Ccb.RedesSociais.Site }}</span>
								</div>
								<div class="col-12 col-lg-6">
									<label>Redes Sociais</label>
									<span>
									  <a v-if="solicitacao.Ccb.RedesSociais.Facebook" :href="facebookLink" class="fab fa-facebook-square"></a>
										<a v-if="solicitacao.Ccb.RedesSociais.Twitter" :href="twitterLink" class="fab fa-twitter"></a>
										<a v-if="solicitacao.Ccb.RedesSociais.Instagram" :href="instagramLink" class="fab fa-instagram"></a>
										<a v-if="solicitacao.Ccb.RedesSociais.Vimeo" :href="vimeoLink" class="fab fa-vimeo-v"></a>
									</span>
								</div>

								<div class="col-12" v-if="formatoInvestimento">
									<div class="alert alert-secondary" role="alert">
										<strong>Formato do Investimento:</strong>  {{formatoInvestimento}}
									</div>
								</div>   
							</div>
							<h4>Índices finaneiros</h4>
							<div class="row">
								<div class="col-12 col-md-3">
									<div class="box">
										<label>Taxa bruta de rendimento</label>
										<p>{{ solicitacao.Ccb.TaxaBrutaRendimento }}% do CDI</p>
									</div>
								</div>								
							</div>

							<div>
								<h4>Motivo da solicitação do empréstimo</h4>
								<p>{{ solicitacao.Motivo }}</p>
							</div>

							<div>
								<h4>Garantias oferecidas</h4>
								<p>{{ solicitacao.Garantia }}</p>              
							</div>

							<div>
								<h4>Tipo de empréstimo</h4>
								<p>CCB</p>
							</div>
						</section>

						

					</div>
					<!-- Final conteúdo -->

					<!-- Inicio sidebar -->
					<aside class="col-12 col-lg-4">
						<div class="box">
							<div class="row no-gutters dates">
								<div class="col-12 col-sm-6">
									<img src="/static/assets/images/ico-calendar_ok.svg">
									<label>Início</label>
									<span class="date">{{ formatMongoDate(solicitacao.InicioCaptacao) }}</span>
								</div>
								<div class="col-12 col-sm-6">
									<img src="/static/assets/images/ico-calendar_end.svg">
									<label>Término</label>
									<span class="date">{{ formatMongoDate(solicitacao.FimCaptacao) }}</span>
								</div>          
							</div>

							<hr class="divider">

							<div class="row">
								<div class="col-12 text-center">
									<label>Valor solicitado</label>
									<span class="value">R$ {{ formatCurrency(solicitacao.Valor) }}</span>
								</div>
							</div>

							<hr class="divider">

							<div class="row">
								<div class="col-12 col-md-12 col-lg-6 text-center">
									<label>Rating</label>
									<span class="info bold">{{ solicitacao.Score }}</span>
								</div>								
								<div class="col-12 col-md-12 col-lg-6 text-center">
									<label>Duração esperada</label>
									<span class="info bold" v-if="solicitacao.PrazoDias > 1">{{solicitacao.PrazoDias}} Dias</span>
									<span class="info bold" v-else>{{solicitacao.Prazo}} Meses</span>
									<!-- <span class="info bold">{{ solicitacao.Prazo }} Meses</span> -->
								</div>
							</div>

							<hr class="divider">

							<div class="row no-gutters text-center">
								<div class="col-12">
									<h5>{{ calcDiasRestantes() }}</h5>
								</div>
								<div class="col-12">
									<div class="clearfix itens">
										<span class="float-left">Levantado: {{ formatCurrency(solicitacao.ValorCaptado) }}</span>										
										<span class="float-right">Faltam: <strong>R$ {{ formatCurrency(calcValorRestante()) }}</strong></span>										
									</div>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="'width:' + calcPercValorRestante() + '%;'" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
											<span class="progress-value">{{ formatCurrency(calcPercValorRestante()) }}%</span>
										</div>
									</div>
								</div>
								<div class="col-12">
									<span class="info__invest"><strong>{{ qtdeInvestidores }}</strong> investidores</span>
								</div>
							</div>

							<hr class="divider">

							<div v-if="canInvest" class="row no-gutters text-center">
								<div v-if="!solicitacao.JaInvestiu" class="col-12 text-center">
									<form @submit.prevent="investir(solicitacao._id, valueToInvest)">
										<div v-if="ccbAberta" class="form-group">
											<input class="form-control form-control-lg" id="valor" v-model="valueToInvest" v-mask="'money'" :placeholder="'Investimento mínimo R$ '+formatCurrency(solicitacao.Valor)">
										</div>
										<button v-if="ccbAberta" type="submit" class="btn btn-primary btn-lg btn-block">Investir</button>
										<button v-else type="button" class="btn btn-primary btn-lg btn-block" style="background-color: gray;">Encerrado</button>																				
									</form>
									<p class="small">** Ao chegar em 100% do valor solicitado, a solicitação é encerrada imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.
									</p>
								</div>
								<div v-else class="confirm">
									<img src="/static/assets/images/ico-confirm.svg" alt="icone de confirmação">
									<p>
										Investimento registrado com sucesso.<br/>
										<small>Você receberá um boleto por email para confirmar o pagamento. O seu pagamento pode ser confirmado em até 48 horas.
										</small>
									</p>
								</div>
							</div>
							<div v-else class="form-row" style="width: 100%">
								<div class="alert alert_reserve alert-warning text-center" style="width: 100%">
									<h2>Falta pouco para você investir</h2>

									<div>
										<p v-if="temCadastroInvestidor && temSuitability && !investidorAprovado" style="font-size: 20px;">Agora estamos analisando suas informações e retornaremos em até 1 dia útil.</p>
										<p v-else>
											<router-link v-if="!temCadastroInvestidor" to="/informacoes-adicionais/investidor" style="font-size: 20px;">Complete o cadastro de investidor</router-link><br/>
											<router-link v-if="!temSuitability" to="/informacoes-adicionais/suitability" style="font-size: 20px;">Preencha o formulário de suitability</router-link>
										</p>
									</div>
								</div>
							</div>

						</div>
					</aside>
					<!-- Final sidebar -->

				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

	@include sm {
		.tit_page {
			h1 {
				&{
					font-size: calcRem(30);
				}

				span {
					font-size: 1rem;
				}
			}
			.back {
				display: none;
			}
		}
		.tit {
			h2 {
				font-size: calcRem(20);
			}
		}
		.company-view {
			section {
				h3 {
					font-size: calcRem(20);
				}

				h2 {
					font-size: calcRem(22);
				}

				span {
					font-size: calcRem(18);
				}
			}
		}
	}

	@include xs {
		.tit_page {
			h1 {
				&{
					font-size: calcRem(20);
				}
				span {
					font-size: calcRem(14);
					padding-left: calcRem(10);
					margin-left: calcRem(10);
					line-height: calcRem(45);
					background-size: 6px;
				}
			}
			.back {
				display: none;
			}
		}

		.tit {
			h2 {
				font-size: calcRem(18);
			}

			span {
				font-size: 1rem;
			}
		}

		.company-view {
			section {
				h3 {
					font-size: calcRem(20);
				}

				h2 {
					font-size: calcRem(22);
				}

				span {
					font-size: calcRem(18);
				}
			}
		}
	}
</style>


<script>
import ApiClient from '../utils/api-client'
import BarChart from '@/components/charts/BarChart'
import Carousel from '@/components/Carousel'
import Masker from '@/utils/masker'
import * as mutationTypes from '@/store/mutation-types.js'
// import ArrayHelper from '@/utils/array-helper'
import InvestmentReservationForm from '@/components/CompanyProfile/InvestmentReservationForm'
// import Promise from 'promise'

export default {
  components: { BarChart, Carousel, InvestmentReservationForm },
  data() {
    return {
		solicitacao: {},
		renderizar: false,
		temCadastroInvestidor: false,
		temSuitability: false,
		investidorAprovado: false,
		qtdeInvestidores: 0,
		valueToInvest: "",
		ccbAberta: true,
    }
  },
 
  computed: {
	scoreClass() {
		if(!this.solicitacao.Score) {
			return ""
		}

		return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase()
	},
	canInvest() {
		return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
	},
	facebookLink() {
		if(this.solicitacao.Ccb.RedesSociais.Facebook.indexOf("http") < 0)
			return 'http://' + this.solicitacao.Ccb.RedesSociais.Facebook;
		
		return this.solicitacao.Ccb.RedesSociais.Facebook;
	},
	instagramLink() {
		if(this.solicitacao.Ccb.RedesSociais.Instagram.indexOf("http") < 0)
			return 'http://' + this.solicitacao.Ccb.RedesSociais.Instagram;
		
		return this.solicitacao.Ccb.RedesSociais.Instagram;
	},
	twitterLink() {
		if(this.solicitacao.Ccb.RedesSociais.Twitter.indexOf("http") < 0)
			return 'http://' + this.solicitacao.Ccb.RedesSociais.Twitter;
		
		return this.solicitacao.Ccb.RedesSociais.Twitter;
	},
	vimeoLink() {
		if(this.solicitacao.Ccb.RedesSociais.Vimeo.indexOf("http") < 0)
			return 'http://' + this.solicitacao.Ccb.RedesSociais.Vimeo;
		
		return this.solicitacao.Ccb.RedesSociais.Vimeo;
	},
	formatoInvestimento(){ return this.solicitacao.FormatoInvestimento },
  },
  methods: {
	  //tagueamento GA
		taggingGA() {
			this.$ga.page({
				page: '/cadastrar-senha',
				title: 'CadastrarSenha',
			})
		},

	validaStatusInvestimento() {
		var resultDt = this.diffDate(new Date(), this.solicitacao.FimCaptacao);

		if (resultDt == "ENCERRADO" || this.solicitacao.ValorCaptado >= this.solicitacao.Valor)
			return false;

		return true;
	},
	investir(solicitacaoId, valueToInvest) {
		var value = Masker.unmaskMoney(valueToInvest);	
		
		if(value == 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "Por favor, insira um valor."
        });

        return;
      }

      if(value < 20000 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor mínimo de investimento em CCB é de R$ 20.000,00."
		});
		
		return;
	}

	if(value > this.solicitacao.Valor - this.solicitacao.ValorCaptado) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor de investimento é maior do que o disponível."
        });

        return;
      }

		this.solicitacao.JaInvestiu = true;		

		this.$forceUpdate();
		
		ApiClient.postInvestirCcb(solicitacaoId, value).then(() => {
			this.finalizado = true;

			setTimeout(() => {
				// this.get(this.id);
				// this.getCountInvestidores(this.id);
			}, 500);
			
		});
	},
	calcPercValorRestante() {
		return this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor;
	},
	calcValorRestante() {
		return this.solicitacao.Valor - this.solicitacao.ValorCaptado;
	},
	formatMongoDate(dt) {
		var date = new Date(dt);

		var day = date.getDate();
		var month = date.getMonth() + 1;
		var year = date.getFullYear();

		day =  day > 9 ? day : ('0' + day);
		month =  month > 9 ? month : ('0' + month);

		return day + '/' + month + '/' + year;
	},
	formatarCnpj(cnpj) {
		return Masker.maskCnpj(cnpj)
	},
    formatarTipoEmprestimo(tipoEmprestimo) {
      var splitedTipoEmprestimo = tipoEmprestimo.split('-');
			if(splitedTipoEmprestimo
			.length > 1) {
        return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
      }

      return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);      
    },
     ajustIdOportunidade(id, qtd) {
      var s = String(id);
      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return s;
    },
    formatCurrency(value) {
      return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
    },
	diffDate(d1, d2) {
		var date1, date2;

		if (d1 == "") {
			date1 = new Date();
		} else {
			date1 = new Date(d1);
			date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
		}

		if (d2 == "") {
			date2 = new Date();
		} else {
			date2 = new Date(d2);
			date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
		}


		var timeDiff = date2.getTime() - date1.getTime();
		var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

		if (diffDays < 0) return "Encerrado";
		if (diffDays == 0) return "Finaliza hoje*";

		return "Finaliza em " + diffDays + " dias*";
	},
	get(id) {

		ApiClient.getCcbById(id).then((response) => {
			this.solicitacao = response.data;
			this.ccbAberta = this.validaStatusInvestimento();
			this.renderizar = true;

			this.$forceUpdate();
		});
	},
	getCountInvestidores(id) {
		ApiClient.getCountCcbInvestors(id).then((response) => {
			this.qtdeInvestidores = response.data;
			this.renderizar = true;
	
			this.$forceUpdate();
		});
	},
	dataLonga(data) {
		var date = new Date(data);
		date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
		var options = { year: "numeric", month: "long", day: "numeric" };
		return date.toLocaleDateString("pt-BR", options);
	},
	calcDiasRestantes() {
		return this.diffDate(new Date(), this.solicitacao.FimCaptacao);
	},
	getInvestidor(solicitacaoId) {
		ApiClient.getInvestidorCcb(solicitacaoId).then(response => {
			if(response.data != null && response.data.Status != 0) {
				this.solicitacao.JaInvestiu = true;
				this.solicitacao.ReservaInvestimento = response.data;
				this.solicitacao.ReservaInvestimento.Valor += ",00";
			} else {
				this.solicitacao.JaInvestiu = false;
			}

			this.$forceUpdate();					
		});
	},
	},
	beforeCreate(){
		this.$store.dispatch('updateUser')
	},
  async created() {
    this.solicitacaoId = this.$route.params.id

		this.$store.commit(mutationTypes.START_LOADING)

		if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined'){
			window.location.href="#/";
		}
		
    //ajuste modal
    if(document.getElementsByTagName("main").length > 0)
			document.getElementsByTagName("main")[0].style.zIndex = "0";

		this.id = this.$route.params.id;

		this.temSuitability = this.$store.state.currentUser.hassuitability == undefined ? false : this.$store.state.currentUser.hassuitability;
		this.temCadastroInvestidor = this.$store.state.currentUser.hasinvestor == undefined ? false : this.$store.state.currentUser.hasinvestor;

		if(this.$store.state.currentUser.investor == null)
			this.investidorAprovado = false;
		else
			this.investidorAprovado = this.$store.state.currentUser.investor.Status == "APROVADO" && this.temCadastroInvestidor;

		this.get(this.id);
		this.getCountInvestidores(this.id);	
		this.getInvestidor(this.id);

	//tagueamento GA
	await this.taggingGA()
  },
}
</script>




// WEBPACK FOOTER //
// src/views/CCBProfile.vue